module.exports = __webpack_public_path__ + "img/header-right.8ee2dec7.png";